import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { EnvelopeSimpleIcon, CheckCircleIcon } from "@phosphor-icons/react";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", {
        email: email.trim(),
        source: "home",
      });
      setSubscribed(true);
      toast.success("You're in. First digest lands Sunday 9 AM PT.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="relative overflow-hidden bg-gradient-to-br from-zinc-950 via-[#0b1f2a] to-black text-white"
      data-testid="home-newsletter"
    >
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#1D78AB]/20 blur-3xl rounded-full" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-500/10 blur-3xl rounded-full" />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 py-20 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur border border-white/20 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest mb-5">
          <EnvelopeSimpleIcon size={12} weight="fill" />
          Sunday Drop Digest
        </div>

        <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter leading-tight">
          The best 6 drops of the week, delivered before coffee.
        </h2>
        <p className="text-zinc-300 mt-5 max-w-xl mx-auto leading-relaxed">
          Hand-picked auctions and fixed-price finds from the sellers you
          follow, plus trending categories. Zero spam, one-click unsubscribe,
          always free.
        </p>

        {subscribed ? (
          <div
            className="mt-10 inline-flex items-center gap-3 bg-emerald-500/15 border border-emerald-400/30 rounded-2xl px-6 py-4 text-emerald-300"
            data-testid="newsletter-success"
          >
            <CheckCircleIcon size={22} weight="fill" />
            <div className="text-left">
              <div className="font-semibold text-white">You're in.</div>
              <div className="text-xs text-emerald-200/80">
                First digest lands Sunday 9 AM PT.
              </div>
            </div>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="mt-10 flex flex-col sm:flex-row gap-2.5 max-w-md mx-auto"
            data-testid="newsletter-form"
          >
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@collector.com"
              className="bg-white/10 border-white/20 text-white placeholder:text-zinc-400 rounded-full h-12 px-5"
              data-testid="newsletter-email-input"
            />
            <Button
              type="submit"
              disabled={loading}
              className="bg-amber-400 hover:bg-amber-300 text-zinc-900 rounded-full h-12 px-6 font-bold shadow-lg shadow-amber-500/20"
              data-testid="newsletter-submit-btn"
            >
              {loading ? "Signing you up…" : "Subscribe free"}
            </Button>
          </form>
        )}

        <p className="text-[11px] text-zinc-500 mt-5">
          By subscribing you agree to receive weekly emails from Bidorah.
          Unsubscribe anytime from any email footer.
        </p>
      </div>
    </section>
  );
}
